import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { GetApplicationsRequest, getPolicyApplicationsApi } from 'api/application';
import { PolicyApplicationDetails } from 'app/slice/policyApplicationDetailsSlice';
import { RootState } from 'app/store';
import { changeDateFormat } from 'lib/utils';
import { ApplicationStatus } from './applicationListSlice';
import { getPolicyApplicationStatusTypesApi } from 'api/policy';

export type { Label } from 'api/application';

// Pagination Data Structure returned by API call
export type Pagination = {
    count: number,
    total: number,
    perPage: number,
    currentPage: number,
    lastPage: number,
}

/**
 * GET applications list
 **/
export const getPolicyApplications = createAsyncThunk(
    '/company/applications',
    async (data: GetApplicationsRequest, { dispatch }) => {
        try {
            const response = await getPolicyApplicationsApi(data);
            dispatch(setPolicyApplications(response.data));
            return response.data;
        } catch (err) {
            return false;
        }
    },
);

/**
 * GET policy application statuses list
 **/
export const getPolicyApplicationStatusTypes = createAsyncThunk(
    '/company/policy-status-types/application',
    async (_, { dispatch }) => {
        try {
            const response = await getPolicyApplicationStatusTypesApi();
            dispatch(setPolicyApplicationStatusTypes(response.data));
            return response.data;
        } catch (err) {
            return false;
        }
    },
);

/**
 * Create Application Slice
 */
export const policyApplicationListSlice = createSlice({
    name: 'applications',
    initialState: {
        policyApplications: [{}] as PolicyApplicationDetails[],
        pagination: {} as Pagination,
        policyApplicationStatusTypes: [] as ApplicationStatus[]
    },
    reducers: {
        setPolicyApplications: (state, { payload }) => {
            state.policyApplications = payload.data;
            state.policyApplications.forEach((application: any) => {
                application.isDeadline = application.is_deadline;
                application.createdAt = changeDateFormat(application.created_at);
                application.cancellationReason = application.cancellation_reason;
            });

            state.pagination = payload.pagination;
            state.pagination.perPage = payload.pagination.per_page;
            state.pagination.currentPage = payload.pagination.current_page;
            state.pagination.lastPage = payload.pagination.last_page;
        },
        setPolicyApplicationStatusTypes: (state, { payload }) => {
            state.policyApplicationStatusTypes = payload.data;
        },
    },
});

export const { setPolicyApplications, setPolicyApplicationStatusTypes } = policyApplicationListSlice.actions;
export const selectPolicyApplications = (state: RootState) => state.policyApplications;
